var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidebar-button-container" },
    [
      !_vm.isMultiSelect
        ? _c(
            "v-layout",
            {
              staticClass: "sidebar-button",
              style: { cursor: _vm.buttonIsDisabled ? "inherit" : "pointer" },
              attrs: {
                "justify-center": "",
                "align-center": "",
                disabled: _vm.disabled
              },
              on: {
                click: _vm.onclick,
                mouseover: _vm.animationEnter,
                mouseleave: _vm.animationLeave
              }
            },
            [
              _vm.icon
                ? _c(
                    "v-icon",
                    {
                      attrs: {
                        disabled: _vm.disabled,
                        color: _vm.iconColor,
                        size: "25px"
                      }
                    },
                    [_vm._v("\n      " + _vm._s(_vm.icon) + "\n    ")]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fadeHeightSideBar", mode: "out-in" } },
        [
          _vm.hoverState
            ? _c(
                "div",
                { staticClass: "sidebar-button-hover" },
                [
                  _c("div", { staticClass: "button-label" }, [
                    _vm._v(_vm._s(_vm.buttonName))
                  ]),
                  _vm._v(" "),
                  _vm.dev
                    ? _c("dev-tag", {
                        style: { zoom: "80%", "margin-left": "10px" },
                        attrs: { position: "relative" }
                      })
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db09894a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db09894a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/SideBar/SidebarButton.vue
// module id = null
// module chunks = 